// src/lib/addonsApi.js
//
// Domain API for practice add-on entitlements. Pure data access - no React.
//
// RLS on practice_addons scopes the read to the caller's practice
// (policy: "practice_addons staff read own" - is_staff() AND practice_id =
// my_practice_id()), so this is a plain SELECT - no practice_id filter
// needed. subscription_addons is a public catalog readable by all.
//
// PostgREST embed: the FK practice_addons.addon_id -> subscription_addons.id
// exists (verified May 2026) so the embed works. Two-step fallback is not
// needed.

import { supabase } from "./supabaseClient";

// Returns a Set of active add-on SKUs for the calling practice.
//
// Only status = 'active' grants feature access - 'pending' / 'cancelled'
// and friends do not. Throws on error so the caller decides how to degrade;
// useActiveAddons maps an error to an EMPTY set on purpose: better to
// under-show a tab than to show a bundle the practice does not own.
export async function fetchActiveAddonSkus() {
  const { data, error } = await supabase
    .from("practice_addons")
    .select("subscription_addons(sku)")
    .eq("status", "active");
  if (error) throw error;

  const set = new Set();
  for (const row of data || []) {
    const sku = row.subscription_addons?.sku;
    if (sku) set.add(sku);
  }
  return set;
}
